import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Counter} from "../../com/counter";
import {
    IFlyerRuntime, IFlyerRuntimePage, IFlyerRuntimePageSpot,
    IFlyerRuntimePageSpotItem,
    IFlyerRuntimePageSpotPromo,
    IFreeItemDto, IFreeItemsInPromo, ItemState, PromosState,
    SellingUnitDto
} from "../../dtos/flyer";
import {toggleDetailsAction} from "../../store/actionsCreator/detailsActionsCreator";
import {IAppState, IDetailsBranch, ISelectedSpot} from "../../store/models";
import {AsyncImage} from "../imageComponent/image";
import {
    calculationCountNumber,
    findCurrentTranslateLabel,
    getPromoCaption, getPromoRegularPriceAndDiscount
} from "../../com/globalsFunctions/globalFunctions";
import {Box, Button, ButtonBase, Grid, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {isMobile, isTablet} from "react-device-detect";
import {toggleShelvesScreen} from "../../store/actionsCreator/shelvesScreenActionsCreator";
import {toggleBasket} from "../../store/actionsCreator/controlsActionsCreator";
import {
    changeTargetItem,
    setAddToMyListOneItemData,
} from "../../store/actionsCreator/addToMyListOneItemActionsCreator";
import {ReactComponent as CheckMarkIcon} from "../../assets/icons/checkmark_icon.svg";
import tinycolor from "tinycolor2";
import {changeMyListItemsAndBenefitItemsAction} from "../../store/actionsCreator/myListActionsCreator";
import {changeMyListData} from "../../store/actionsCreator/changeMyListDataActionCreator";
import {StoreProjectDto} from "../../dtos/siteDto";

const useStyles = makeStyles(() => ({
    box: {
        display: `flex`,
        alignItems: `center`,
        justifyContent: `center`,
    },
    itemWrapperNew: (props: any) => ({
        // margin: props.promoItemsLength !== 1 ? `2px` : `0`,
        // height: props.promoItemsLength !== 1 ? `288px` : `100%`,
        display: `flex`,
        overflow: `auto`,
        flexFlow: `column`,
        padding: `5px`,
        "& .MuiTypography-root": {
            fontFamily: props.fontFamily,
            textAlign: 'initial',
            '&.textAlignEnd': {
                textAlign: `end`,
            }
        },
        borderRadius: `4px`,

        position: `relative`,
        '&:hover': {
            '& .captionForCheckbox': {
                display: `block`
            }
        }
        // '&:hover': {
        //     backgroundColor: `#ffffff`
        // }
    }),
    itemImageWrapper: (props: any) => ({
        height: `100%`,
        // backgroundColor: props.isExpandedPopup && props.promoItemsLength === 1 && !props.isMobile ? `#0000000D` : `transparent`,
        // maxHeight: props.isExpandedPopup && props.promoItemsLength === 1 ? `100%` : `55%`,
        // minHeight: props.isExpandedPopup && props.promoItemsLength === 1 ? `100%` : `55%`,
        width: `100%`,
        position: `relative`,
        '&:hover': {
            '& .MuiTypography-root': {
                display: `block`
            }
        }
    }),
    checkmarkIconBlock: {
        height: `30px`,
        // minWidth: `20px`,
        backgroundColor: `#38B524`,
        position: `absolute`,
        top: `0`,
        right: `0`,
        display: `flex`,
        alignItems: `center`,
        justifyContent: `center`,
        zIndex: 1
    },
    itemDetails: {
        flex: `1 1 auto`,
        padding: `0 5px`,
        display: `flex`,
        flexFlow: `column`,
        height: `100%`
    },

    itemCaption1: {
        '& .MuiTypography-root': {
            fontWeight: `600`,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: `inherit!important`,
            display: "-webkit-box",
            "-webkit-line-clamp": 2,
            "-webkit-box-orient": "vertical"
        },
    },
    itemRegPriceWrapperForOneItem: {
        display: `flex`,
        flexFlow: `row`,
        alignItems: `center`,
        justifyContent: "space-between",
    },
    itemRegPriceWrapper: {
        display: `flex`,
        flex: `1 1 auto`,
        flexFlow: `row`,
        alignItems: `center`,
    },

    itemRegPrice: {
        display: `flex`,
        flex: `1 1 auto`,
        alignItems: `baseline`,
    },
    itemActions: {
        // flex: `1 1 auto`,
        display: `flex`,
        flexFlow: `row`,
        margin: `5px 0`
    },
    pricelessDesignActions: {
        flex: `1 1 auto`,
        display: `flex`,
        flexDirection: `column`,
        justifyContent: `flex-end`
    },
    itemCounter: {
        display: `flex`,
    },

    itemShelfBtn: {
        flex: `1 1 auto`,
        display: `flex`,
        justifyContent: `flex-end`,
        "& > .MuiButton-root": {
            display: "flex",
            alignItems: "center"
        }
    },

    itemWrapper: (props: any) => ({
        padding: `10px`,
        borderBottom: '1px solid #858585',
        // '&:last-child': {
        //     border: `none`
        // },
        "& > .MuiTypography-root": {
            fontFamily: props.fontFamily,
            textAlign: 'initial',
        },
        '&:hover': {
            backgroundColor: `rgba(228, 228, 228, 0.8)`
        }
    }),
    itemCaption: (props: any) => ({
        '&.MuiTypography-root': {
            fontSize: props.isMobile ? `18px` : `16px`,
            lineHeight: '24px',
            wordBreak: `break-word`,
        }
    }),
    boxForImage: {
        width: '100%',
        height: '110px',
        display: `flex`,
        justifyContent: 'center',
    },
    itemPricesContainer: {
        height: `100%`,
        display: `flex`,
        flexDirection: `column`,
        textAlign: "end"
        // justifyContent: `space-between`,
    },
    itemPriceBox: {
        // display: 'flex',
        // justifyContent: 'flex-end',
        paddingBottom: '10%'
    },
    itemControls: {
        justifyContent: 'space-between',
        minHeight: `24px`,
    },
    itemTrashBtn: (props: any) => ({
        '&.MuiButton-root': {
            width: `26px`,
            height: `26px`,
            '&:hover': {
                backgroundColor: props.backgroundColor ? `${props.backgroundColor}BF` : '#C32E43BF',
                '& svg path': {
                    fill: '#ffffff',
                    stroke: '#ffffff'
                }
            },
            '&:active': {
                backgroundColor: props.backgroundColor ? `${props.backgroundColor}33` : '#C32E4333',
                '& svg path': {
                    fill: '#ffffff',
                    stroke: '#ffffff'
                }
            }
        },
        "& svg path": {
            fill: props.backgroundColor
        }
    }),

    infoBtnsWrapper: {
        justifyContent: 'flex-start',
        '& > .MuiButton-root': {
            padding: '0',
            '& > .MuiTypography-root': {
                '&:hover': {
                    fontWeight: `900`
                }
            }
        },
        '& > .Mui-disabled': {
            opacity: `0.5`
        }
    },
    customTooltip: {
        '&.MuiTooltip-tooltip': {
            padding: '0',
            border: `none`,
            backgroundColor: '#ffffff',
            color: "#000000",
            maxWidth: `inherit`,
            margin: `0`,
        }
    },
    addItemBtn: (props: any) => ({
        display: `flex`,
        width: `100%`,
        height: `100%`,
        '&.MuiButton-root': {
            backgroundColor: props.backgroundColor,
            border: props.isLightGuiColor ? `1px solid ${props.fontsGuiColor}` : "none",
        },
        '&:hover': {
            backgroundColor: props.backgroundColor ? `${props.backgroundColor}B3!important` : '#C32E43B3!important',
        },
        '&.Mui-disabled': {
            color: "white!important",
            backgroundColor: props.backgroundColor ? `${props.backgroundColor}4D!important` : '#C32E43B3!important',
        },
        '& > .MuiTypography-root': {
            fontWeight: "bold",
            lineHeight: `1`,
            fontSize: `16px`,
            color: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
        }
    }),
    giftItemWrapper: {
        width: `100%`,
        textAlign: `end`,
        '&.MuiTypography-root': {
            fontWeight: 'bold'
        }
    },

    promotionDetails: {
        display: `flex`,
        flexDirection: `column`
    },
    promotionCaption: (props: any) => ({
        '& > .MuiTypography-root': {
            fontWeight: `400`,
            fontSize: props.promoItemsLength === 1 && !props.isMobile ? `24px!important` : `20px!important`,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: `inherit`,
            // maxWidth: `100%`,
            display: "-webkit-box",
            "-webkit-line-clamp": props.isExpandedPopup && props.promoItemsLength === 1 && !props.isMobile ? 3 : 2,
            "-webkit-box-orient": "vertical"
        }
    }),
    promotionType: {
        marginTop: `4px`,
        display: `flex`,
        alignItems: `baseline`,
        '& > .MuiTypography-root': {
            // fontSize: `18px`,
            // color: `#5A5A5A`
        }
    },
    promotionDate: (props: any) => ({
        '& > .MuiTypography-root': {
            fontSize: props.isMobile ? `14px!important` : `16px!important`,
            color: `#5A5A5A`
        }
    }),
    promotionPricesSection: (props: any) => ({
        display: `flex`,
        flexFlow: `column`,
        margin: props.isMobile ? `0` : `10px 0`,
        justifyContent: `center`,
        '& .MuiTypography-root': {
            lineHeight: '24px'
        }
    }),
    promotionRegPrice: {
        marginBottom: `4px`,
    },
    promotionSaving: {
        marginBottom: `4px`,
        '& .MuiTypography-root': {
            color: '#C32E43'
        }
    },
    promotionTotalPrice: {
        '& .MuiTypography-root': {
            fontWeight: `700`
        }
    },
    orderCostInfoRowNew: (props: any) => ({
        minHeight: '24px',
        '& .MuiTypography-root': {
            fontSize: props.isMobile ? `14px` : `16px`
        }
    }),

}));

type Props = {
    item: IFlyerRuntimePageSpotItem;
    currentItemCount: number;
    promoType: number;
    promoQty: number;
    promoSalePrice: number;
    promoGetAmountOff: number;
    promoItems: IFlyerRuntimePageSpotItem[],
    promotionSellingUnit?: SellingUnitDto;
    promoDisplayCaption: string;
    isPricelessFlyer: boolean;
    isShowPromoCaption: boolean;
    promo: IFlyerRuntimePageSpotPromo;
//   handleClearItem: (item: IFlyerRuntimePageSpotItem) => void;
};

export const Item: React.FC<Props> = ({
                                          currentItemCount,
                                          //   handleClearItem,
                                          item,
                                          promoType,
                                          promoQty,
                                          promoSalePrice,
                                          promoItems,
                                          promotionSellingUnit,
                                          promoDisplayCaption,
                                          promoGetAmountOff,
                                          isPricelessFlyer,
                                          isShowPromoCaption,
                                          promo,
                                      }) => {
    const {
        displayCaption1,
        imageThumbnail: thumbnailImage,
        image,
        regularPrice,
        isBenefit
    } = item;
    const timeoutIdRef = useRef<NodeJS.Timeout | null>(null);
    const canvasRef = useRef(null);
    const storeGlobalData = useSelector<IAppState, StoreProjectDto | null>((state) => state.storeData);
    const flyerBranch = useSelector<IAppState, IFlyerRuntime | null>((state) => state.flyersBranch.data);
    const storeData = useSelector((state: IAppState) => state.shelvesScreen.data);
    const settingForPopup = storeGlobalData?.isFromFlyer ? flyerBranch : storeData?.storeSetting;

    // const flyerBasic = useSelector((state: IAppState) => state.flyerBranchBasic.data);
    const isLightGuiColor = tinycolor(settingForPopup?.primaryColorRgb || "#C32E43").isLight();
    const fontsGuiColor = settingForPopup?.fontsColorRgb || "#000000";
    const {myListState} = useSelector((state: IAppState) => state);
    const {isExpanded} = useSelector<IAppState, ISelectedSpot>(state => state.selectedSpot);
    const isRtl = settingForPopup?.dir?.toLowerCase() === "rtl";

    // const {data} = useSelector((state: IAppState) => state.flyersBranch);
    const {shelvesScreen} = useSelector((state: IAppState) => state);
    const totalCaption = findCurrentTranslateLabel(169, 'Regular Price', settingForPopup);
    const validToCaption = findCurrentTranslateLabel(196, 'Valid unlit date', settingForPopup);
    const freeItemsCaption = findCurrentTranslateLabel(603, 'Free Items', settingForPopup);
    const discountCaption = findCurrentTranslateLabel(193, 'Save', settingForPopup);
    const salePriceCaption = findCurrentTranslateLabel(194, 'Sale Price', settingForPopup);
    const itemsCaption = findCurrentTranslateLabel(144, 'items', settingForPopup);
    // const isShowPromoCaption = isPricelessFlyer &&
    //     (promoType === 20 ||
    //         promoType === 21 ||
    //         promoType === 50 ||
    //         promoType === 51);
    const {controlsBranch} = useSelector((state: IAppState) => state);
    const {showBasket} = controlsBranch;
    // const [totalSumSumOfItem, setTotalSumOfItem] = useState<number>(0);
    const dispatch = useDispatch();
    const detailsBranch = useSelector<IAppState, IDetailsBranch | null>(
        (state) => state.detailsBranch
    );
    const {addToMyListOneItemData} = useSelector((state: IAppState) => state);
    const [isImageExist, setImageExistStatus] = useState(false);
    const [isVisibleAddBtn, setVisibleAddBtn] = useState<boolean>(true);
    // const [isAnimationStart, setAnimationStatus] = useState<boolean>(false);
    //translate captions
    // const moreInfoCaption = findCurrentTranslateLabel(145, "More Info", settingForPopup);
    const showShelfCaption = findCurrentTranslateLabel(146, "Show Shelf", settingForPopup);
    const addCaption = findCurrentTranslateLabel(602, "add", settingForPopup);
    // const qty = findCurrentTranslateLabel(199, "Qty", settingForPopup);
    // const addOneFree = findCurrentTranslateLabel(195, "free", settingForPopup);
    const regularPriceCaption = findCurrentTranslateLabel(169, "Regular Price", settingForPopup);
    const giftCaption = findCurrentTranslateLabel(616, "Gift", settingForPopup);
    const pickedMultiLangCaption = findCurrentTranslateLabel(656, 'Picked', settingForPopup);
    const [count, setCount] = useState<string>(currentItemCount.toString());
    const [itemState, setItemState] = useState<IFlyerRuntimePageSpotItem>(item);
    const [items, setItems] = useState<ItemState[]>([]);
    const [promoCaption, setPromoCaption] = useState<string>('');
    const [toDate, setTo] = useState<any>('');
    const [freeQtyItems, setFreeItemsQty] = useState<IFreeItemDto[]>([]);
    const [totalFreeItemsCount, setTotalFreeItemsCount] = useState<number>(0);
    const [totalItemsCount, setTotalItemsCount] = useState<number>(0);
    const [totalSalePrice, setTotalPrice] = useState<number>(0);
    const [discount, setDiscount] = useState<number>(0);
    const [totalRegularPrice, setTotalRegularPrice] = useState<number>(0);
    const [itemImageSrc, setImageSrc] = useState<string>(item.image || "");


    // const isDevAndQAEnvironment = settingForPopup?.environment && (settingForPopup?.environment?.toLowerCase().indexOf('dev') > -1 || settingForPopup?.environment?.toLowerCase().indexOf('qa') > -1);
    const isStoreAvailableForFlyer = settingForPopup && settingForPopup.supportedFeatures && settingForPopup.supportedFeatures.isStore ? settingForPopup.supportedFeatures.isStore : false;
    const styleProps = {
        backgroundColor: settingForPopup?.primaryColorRgb || "#C32E43",
        direction: settingForPopup?.dir,
        fontFamily: settingForPopup?.font?.toLowerCase(),
        isMobile: isMobile,
        promoItemsLength: promoItems.length,
        isExpandedPopup: isExpanded,
        isLightGuiColor: isLightGuiColor,
        fontsGuiColor: fontsGuiColor
    };
    const classes = useStyles(styleProps);


    useEffect(() => {
        setItemState(item);
        if (storeGlobalData?.isFromFlyer) {
            toTimeStamp(settingForPopup?.validTo);
        }
        let itemImageSrc = item.image || "";

        if (storeGlobalData?.isFromFlyer) {
            const pageForItem = settingForPopup?.pages.find((page: IFlyerRuntimePage) =>
                page.spots.some((frame: IFlyerRuntimePageSpot) =>
                    frame.promo?.items.some((promoItem: IFlyerRuntimePageSpotItem) => promoItem.id === item.id)
                )
            );
            itemImageSrc = item.image && item.image !== '' ? item.image : pageForItem ? "frameScreenshot" : "";
        }

        setImageSrc(itemImageSrc);
        setPromoCaption(getPromoCaption(promo!, isRtl, settingForPopup?.currencySymbol || "$", settingForPopup?.saleTypes || [], promotionSellingUnit));
        // console.log(from,'from');
        const toToCompair = toTimeStamp(promo?.promoValidToUtc.substring(0, 10));
        // console.log(fromToCompair,'fromToCompair');
        const mediumTo = new Date(toToCompair)
        const to = mediumTo.getDate() +
            "/" + (mediumTo.getMonth() + 1 < 10 ? `0${mediumTo.getMonth() + 1}` : mediumTo.getMonth() + 1) +
            "/" + mediumTo.getFullYear()
        setTo(to);
    }, []);


    useEffect(() => {
        const myListItemsForCurrentPromo: ItemState[] = getCurrentItemsForSelectedFrameInMyList(myListState.promos);
        const myListBenefitItemsForCurrentPromo: IFreeItemDto[] = getCurrentBenefitItemsForSelectedFrameInMyList(myListState.benefitItems);
        setFreeItemsQty(myListBenefitItemsForCurrentPromo);
        setItems(myListItemsForCurrentPromo);
    }, [myListState.promos, myListState.benefitItems]);

    useEffect(() => {
        setCount(currentItemCount.toString());
    }, [currentItemCount])

    useEffect(() => {
        const freeItemsNumber = getTotalBenefitItemsCount(freeQtyItems);
        const totalItems = getTotalItems(items, promo, freeQtyItems);
        setTotalFreeItemsCount(freeItemsNumber);
        setTotalItemsCount(totalItems);
        const newPromo: PromosState = {
            ...promo!,
            items: items
        }
        let sumOfDiscount: number = getPromoRegularPriceAndDiscount(newPromo, items, freeQtyItems);
        setDiscount(sumOfDiscount);
        const totalPrice = getTotalPrice(items, promo);
        setTotalPrice(totalPrice - sumOfDiscount);
        setTotalRegularPrice(totalPrice);
        return () => {
            setTotalFreeItemsCount(0);
        }
    }, [freeQtyItems, promo, items])

    useEffect(() => {
        const hasStartOrEndPeriod = /^\.|\.($|\s)/.test(count);
        if (hasStartOrEndPeriod) {
            return;
        }
        setVisibleAddBtn(Number(count) <= 0);
        if (timeoutIdRef.current) {
            clearTimeout(timeoutIdRef.current);
        }
        timeoutIdRef.current = setTimeout(() => {
            changeMyListState(Number(count));
        }, 501);
    }, [count]);

    useEffect(() => {
        if (canvasRef.current && storeGlobalData?.isFromFlyer) {
            const pageForItem = settingForPopup?.pages.find((page: IFlyerRuntimePage) =>
                page.spots.some((frame: IFlyerRuntimePageSpot) =>
                    frame.promo?.items.some((promoItem: IFlyerRuntimePageSpotItem) => promoItem.id === item.id)
                )
            );

            if (pageForItem) {
                const spotForItem = pageForItem.spots.find((frame: IFlyerRuntimePageSpot) =>
                    frame.promo?.items.some((promoItem: IFlyerRuntimePageSpotItem) => promoItem.id === item.id)
                );

                const canvasContainer = canvasRef.current as HTMLCanvasElement | null;
                if (canvasContainer && pageForItem.displayImageUrl && spotForItem) {
                    const image = new Image();
                    const ctx = canvasContainer.getContext("2d");
                    canvasContainer.style.width = 'inherit';
                    canvasContainer.style.height = 'inherit';
                    canvasContainer.width = canvasContainer.offsetWidth;
                    canvasContainer.height = canvasContainer.offsetHeight;
                    image.src = pageForItem.displayImageUrl;
                    image.addEventListener('load', () => {
                        if (ctx) {
                            let imgWidth = spotForItem.spotX1PX - spotForItem.spotX0PX;
                            let screenWidth = canvasContainer.width;
                            let scaleX = screenWidth / imgWidth;
                            let imgHeight = spotForItem.spotY1PX - spotForItem.spotY0PX;
                            let screenHeight = canvasContainer.height;
                            let scaleY = screenHeight / imgHeight;
                            let scale = scaleY;
                            if (scaleX < scaleY) {
                                scale = scaleX;
                            }
                            imgHeight = imgHeight * scale;
                            imgWidth = imgWidth * scale;
                            canvasContainer.style.width = `${imgWidth}px`;
                            canvasContainer.style.height = `${imgHeight}px`;
                            canvasContainer.height = imgHeight;
                            canvasContainer.width = imgWidth;

                            ctx.drawImage(
                                image,
                                spotForItem.spotX0PX, //x0
                                spotForItem.spotY0PX, // y0 Start at 70/20 pixels from the left and the top of the image (crop),
                                spotForItem.spotX1PX - spotForItem.spotX0PX, //x1 - x0
                                spotForItem.spotY1PX - spotForItem.spotY0PX, //y1 - y0 "Get" a `50 * 50` (w * h) area from the source image (crop),
                                0,
                                0, // Place the result at 0, 0 in the canvas,
                                // 100 * props.frame.fpsWidthPx! / props.frame.fpsHeightPx!,
                                // 100 * props.frame.fpsHeightPx! / props.frame.fpsWidthPx!
                                imgWidth,
                                imgHeight
                            ); // With as width / height: 100 * 100 (scale)

                        }
                    })

                }
            }
        }
    }, [canvasRef.current, itemImageSrc])


    // useEffect(() => {
    // const isExistFreeItemForItem = freeQtyItems.find((freeItem: IFreeItemDto) => freeItem.itemID === item.id);
    // if (isExistFreeItemForItem) {
    //     setFreeItemNumber(isExistFreeItemForItem.itemCount!);
    // }
    // if (!isExistFreeItemForItem) {
    //     setFreeItemNumber(0);
    // }
    // }, [freeQtyItems]);

    const toTimeStamp = (aftercut: any) => {
        return Date.parse(aftercut);
    }
    const onClick = () => {
        console.log(`click on image in addtomylist or mylist`);
        // look this
        if (!Boolean(addToMyListOneItemData.data)) {
            const newItemsArrayWithCurrentPromo = promo.items.map((item: IFlyerRuntimePageSpotItem) => {
                return {
                    ...item,
                    promo: promo
                }
            })
            dispatch(setAddToMyListOneItemData(
                {
                    promoDetails: promo,
                    targetItem: item,
                    itemsArray: isRtl ? newItemsArrayWithCurrentPromo.reverse() : newItemsArrayWithCurrentPromo
                },
                true
            ))
        } else {
            dispatch(changeTargetItem(item))
        }
        // dispatch(toggleDetailsAction({...item}));
    };

    const onClickPlusMinusBtn = (operation: "increase" | "decrease") => {
        const increment = promotionSellingUnit ? promotionSellingUnit.guiIncrement : 1;
        const maxNumber = promotionSellingUnit ? promotionSellingUnit.maxQty : 99;
        if (operation === "increase") {
            if (Number(count) < maxNumber) {
                const countNumber = (Number(count) === 0 && promo && promo.promoSaleTypeCode === 70 && promo.promoBuyQty)
                    ? promo.promoBuyQty
                    : calculationCountNumber(
                        Number(count),
                        increment,
                        true,
                        promotionSellingUnit
                    );
                setCount(countNumber.toString());
            }
        } else {
            const countNumber = calculationCountNumber(
                Number(count),
                increment,
                false,
                promotionSellingUnit
            );
            setCount(countNumber.toString());
        }

    }

    const onChangeCountNumber = (value: string) => {
        const maxNumber = promotionSellingUnit ? promotionSellingUnit.maxQty : 99;
        const increment = promotionSellingUnit ? promotionSellingUnit.guiIncrement : 1;
        const onlyNumbersAndOneDot = new RegExp(/^(\d+\.?\d{0,3}|\.\d{1,3}|\.)$/i);
        const onlyNumbers = new RegExp(/^\d+$/i);
        const isValidCode = increment.toString().indexOf(".") === -1 && promotionSellingUnit?.id !== 11 ? onlyNumbers.test(value) : onlyNumbersAndOneDot.test(value);
        if (!isValidCode || Number(value) < 0 || Number(value) > maxNumber) {
            return;
        }
        setCount(value);
    }


    const getCurrentItemsForSelectedFrameInMyList = (promos: PromosState[]): ItemState[] => {
        if (!promos.length) {
            return [];
        }
        const currentPromoInFrame = promos.find(promoInBasket => promoInBasket.promoId === promo?.promoId);
        return currentPromoInFrame?.items || [];
    }

    const getCurrentBenefitItemsForSelectedFrameInMyList = (benefitItemsPromo: IFreeItemsInPromo[]): IFreeItemDto[] => {
        const currentPromoInFrame = benefitItemsPromo.find(promoInBasket => promoInBasket.promoId === promo?.promoId);
        return currentPromoInFrame?.freeItems || [];
    }

    const changeMyListState = (currentItemCount: number) => {
        let newItemsForCurrentPromo: ItemState[] = [];
        const currentPromoItems = getCurrentItemsForSelectedFrameInMyList(myListState.promos);
        const selectedItem = currentPromoItems.find(_item => _item.spotItem.id === itemState.id);
        const maxNumber = promotionSellingUnit ? promotionSellingUnit.maxQty : 99;
        const newItems = [...currentPromoItems];
        if (currentItemCount > 0) {
            if (selectedItem) {
                if (currentItemCount <= maxNumber) {
                    const countNumber = currentItemCount;
                    const modifiedItem = newItems.find((_item) => _item.spotItem.id === itemState.id);
                    if (modifiedItem) {
                        const modifiedIndex = newItems.indexOf(modifiedItem);
                        newItems[modifiedIndex] = {
                            ...modifiedItem, // create a shallow copy of the item
                            count: countNumber // modify the count property
                        };
                    }
                    if (promo?.promoSaleTypeCode === 80) {
                        const benefitItem = promo?.items.find((item: IFlyerRuntimePageSpotItem) => {
                            if (item.isBenefit) {
                                return item;
                            }
                        })
                        if (benefitItem) {
                            const regularItemsWithoutBenefitItems = newItems.filter((item: ItemState) => {
                                if (!item.spotItem.isBenefit) {
                                    return item;
                                }
                            });
                            const totalRegularItemsNumber: number = parseFloat(regularItemsWithoutBenefitItems.reduce((acc, item) => {
                                let count = item.count;
                                return acc + count;
                            }, 0).toFixed(2));
                            const countForGiftItem = Math.floor(totalRegularItemsNumber / (promo?.promoBuyQty ? promo?.promoBuyQty : 0));
                            const benefitItemInItemArray = currentPromoItems.find((item: ItemState) => {
                                if (item.spotItem.id === benefitItem.id) {
                                    return item;
                                }
                            });
                            if (benefitItemInItemArray) {
                                benefitItemInItemArray.count = countForGiftItem;
                            } else {
                                if (countForGiftItem > 0) {
                                    const finalObject = {
                                        spotItem: benefitItem,
                                        count: countForGiftItem
                                    }
                                    newItems.push(finalObject);
                                }
                            }
                        }
                    }
                    newItemsForCurrentPromo = newItems;
                }
            } else {
                let newItemsArray = [
                    {
                        spotItem: itemState,
                        count: currentItemCount
                    }
                ]
                if (promo?.promoSaleTypeCode === 80) {
                    const benefitItem = promo?.items.find((item: IFlyerRuntimePageSpotItem) => {
                        if (item.isBenefit) {
                            return item;
                        }
                    })
                    if (benefitItem) {
                        const totalRegularItemsNumber: number = parseFloat([...currentPromoItems, ...newItemsArray].reduce((acc, item) => {
                            let count = item.count;
                            return acc + count;
                        }, 0).toFixed(2));
                        const countForGiftItem = Math.floor(totalRegularItemsNumber / (promo?.promoBuyQty ? promo?.promoBuyQty : 0));
                        const benefitItemInItemArray = currentPromoItems.find((item: ItemState) => {
                            if (item.spotItem.id === benefitItem.id) {
                                return item;
                            }
                        });
                        if (benefitItemInItemArray) {
                            benefitItemInItemArray.count = countForGiftItem;
                        } else {
                            if (countForGiftItem > 0) {
                                const finalObject = {
                                    spotItem: benefitItem,
                                    count: countForGiftItem
                                }
                                newItemsArray.push(finalObject);
                            }
                        }
                    }
                }
                newItemsForCurrentPromo = [...currentPromoItems, ...newItemsArray];
            }
        } else {
            newItemsForCurrentPromo = newItems.filter(_item => _item.spotItem.id !== item.id);
            if (promo?.promoSaleTypeCode === 80) {
                const benefitItem = promo?.items.find((item: IFlyerRuntimePageSpotItem) => {
                    if (item.isBenefit) {
                        return item;
                    }
                })
                if (benefitItem) {
                    const regularItemsWithoutBenefitItems = newItemsForCurrentPromo.filter((item: ItemState) => {
                        if (!item.spotItem.isBenefit) {
                            return item;
                        }
                    });
                    const totalRegularItemsNumber: number = parseFloat(regularItemsWithoutBenefitItems.reduce((acc, item) => {
                        let count = item.count;
                        return acc + count;
                    }, 0).toFixed(2));
                    const countForGiftItem = Math.floor(totalRegularItemsNumber / (promo?.promoBuyQty ? promo?.promoBuyQty : 0));
                    const benefitItemInItemArray = newItemsForCurrentPromo.find((item: ItemState) => {
                        if (item.spotItem.id === benefitItem.id) {
                            return item;
                        }
                    });
                    if (benefitItemInItemArray) {
                        benefitItemInItemArray.count = countForGiftItem;
                    } else {
                        if (countForGiftItem > 0) {
                            const finalObject = {
                                spotItem: benefitItem,
                                count: countForGiftItem
                            }
                            newItemsForCurrentPromo.push(finalObject);
                        }
                    }
                }
            }
        }
        let newBenefitItemsForCurrentPromo: IFreeItemDto[] = getBenefitItemsAfterChange(newItemsForCurrentPromo);
        changeItemsInBasket(newItemsForCurrentPromo, newBenefitItemsForCurrentPromo);
    };

    const getBenefitItemsAfterChange = (items: ItemState[]): IFreeItemDto[] => {
        const benefitItemsInMyList = myListState.benefitItems;
        let freeQtyItems: IFreeItemDto[] = getCurrentBenefitItemsForSelectedFrameInMyList(benefitItemsInMyList);
        if (promo?.promoSaleTypeCode === 51) {
            const totalItemsCount = getTotalItemsCount(items);
            if (promo?.promoBuyQty && totalItemsCount !== 0) {
                const cheapestItemInItemsArray = items.reduce((prev, curr) => {
                    return prev.spotItem.regularPrice < curr.spotItem.regularPrice ? prev : curr;
                });
                let newFreeItemsArray: IFreeItemDto[] = [];
                items.forEach((item: ItemState) => {
                    if (promo?.promoBuyQty! <= item.count) {
                        newFreeItemsArray = [
                            ...newFreeItemsArray,
                            {
                                itemCount: item.count % promo?.promoBuyQty! === 0 ? item.count / promo?.promoBuyQty! : Math.floor(item.count / (promo?.promoBuyQty!)),
                                itemID: item.spotItem.id,
                                benefitItemCaption: item.spotItem.displayCaption1
                            }]
                    }
                });
                const totalAlreadyCalculatedFreeItems = parseFloat(
                    newFreeItemsArray
                        .reduce((acc, item) => {
                            if (item) {
                                return acc + item?.itemCount!;
                            } else {
                                return 0;
                            }
                        }, 0)
                        .toFixed(2)
                )
                const numberOfNotCalculatedItems = totalItemsCount - totalAlreadyCalculatedFreeItems * promo?.promoBuyQty;
                if (numberOfNotCalculatedItems !== 0) {
                    const isCheapestItemExistInNewArray = newFreeItemsArray.some((freeItem: IFreeItemDto) => freeItem.itemID === cheapestItemInItemsArray.spotItem.id);
                    if (isCheapestItemExistInNewArray) {
                        newFreeItemsArray.forEach((freeItem: IFreeItemDto) => {
                            if (cheapestItemInItemsArray.spotItem.id === freeItem.itemID) {
                                freeItem.itemCount! += numberOfNotCalculatedItems % promo?.promoBuyQty! === 0 ? numberOfNotCalculatedItems / promo?.promoBuyQty! : Math.floor(numberOfNotCalculatedItems / (promo?.promoBuyQty!));
                            }
                        })
                    } else {
                        newFreeItemsArray = [
                            ...newFreeItemsArray,
                            {
                                itemCount: numberOfNotCalculatedItems % promo?.promoBuyQty! === 0 ? numberOfNotCalculatedItems / promo?.promoBuyQty! : Math.floor(numberOfNotCalculatedItems / (promo?.promoBuyQty!)),
                                itemID: cheapestItemInItemsArray.spotItem.id,
                                benefitItemCaption: cheapestItemInItemsArray.spotItem.displayCaption1
                            }
                        ]
                    }
                }
                freeQtyItems = newFreeItemsArray;
                // if (JSON.stringify(newFreeItemsArray) !== JSON.stringify(freeQtyItems)) {
                //     freeQtyItems = newFreeItemsArray;
                // setFreeItemsQty(newFreeItemsArray);
                // }
            }
        }

        if (promo?.promoSaleTypeCode === 50) {
            const totalItemsCount = getTotalItemsCount(items);
            if (promo?.promoBuyQty && totalItemsCount !== 0) {
                let newFreeItemsArray: IFreeItemDto[] = [];
                items.forEach((item: ItemState) => {
                    if (promo?.promoBuyQty! <= item.count) {
                        newFreeItemsArray = [
                            ...newFreeItemsArray,
                            {
                                itemCount: item.count % promo?.promoBuyQty! === 0 ? item.count / promo?.promoBuyQty! : Math.floor(item.count / (promo?.promoBuyQty!)),
                                itemID: item.spotItem.id,
                                benefitItemCaption: item.spotItem.displayCaption1
                            }]
                    }
                });
                // if (JSON.stringify(newFreeItemsArray) !== JSON.stringify(freeQtyItems)) {
                freeQtyItems = newFreeItemsArray;
                // setFreeItemsQty(newFreeItemsArray);
                // }
            }
        }

        return items.length ? freeQtyItems : [];

    }

    const changeItemsInBasket = (newItemsForCurrentPromo: ItemState[], newBenefitItemsForCurrentPromo: IFreeItemDto[]) => {
        let promos: PromosState[] = [...myListState.promos];
        let freeItemsForFlyer: IFreeItemsInPromo[] = myListState.benefitItems;
        if (promos.length) {
            let selectedSpot = promos.find(promoInBasket => promoInBasket.promoId === promo?.promoId);
            if (selectedSpot) {
                if (newItemsForCurrentPromo.length) {
                    const modifiedPromoIndex = promos.indexOf(selectedSpot);
                    promos[modifiedPromoIndex] = {
                        ...selectedSpot, // create a shallow copy of the item
                        items: newItemsForCurrentPromo // modify the count property
                    };
                    const modifiedPromo = promos[modifiedPromoIndex];
                    for (let i = 0; i < newItemsForCurrentPromo.length; i++) {
                        const selectedItem = modifiedPromo.items.find((modifiedItem: ItemState) => modifiedItem.spotItem.id === newItemsForCurrentPromo[i].spotItem.id);
                        if (selectedItem) {
                            if (modifiedPromo.promoSaleTypeCode === 80) {
                                const totalCountOfItemsWithoutBenefit = parseFloat(
                                    modifiedPromo.items
                                        .reduce((acc, item) => {
                                            if (!item.spotItem.isBenefit) {
                                                return acc + item.count;
                                            }
                                            return acc
                                        }, 0)
                                        .toFixed(2)
                                )

                                if (totalCountOfItemsWithoutBenefit % modifiedPromo.promoBuyQty! === 0) {
                                    const benefitItem = modifiedPromo.items.find(basketItem => basketItem.spotItem.isBenefit);
                                    if (benefitItem && modifiedPromo.promoBuyQty && benefitItem.spotItem.id !== newItemsForCurrentPromo[i].spotItem.id) {
                                        const isBenefitItemAlreadyInMyList = modifiedPromo.items.some((item: ItemState) => item.spotItem.id === benefitItem.spotItem.id);
                                        if (isBenefitItemAlreadyInMyList) {
                                            benefitItem.count = totalCountOfItemsWithoutBenefit / modifiedPromo.promoBuyQty!
                                        } else {
                                            modifiedPromo.items = [
                                                ...promos[modifiedPromoIndex].items, benefitItem
                                            ]
                                        }
                                    }
                                }
                            }
                        } else {
                            modifiedPromo.items = [
                                ...modifiedPromo.items, items[i]
                            ]
                            if (modifiedPromo.promoSaleTypeCode === 80) {
                                const totalCountOfItemsWithoutBenefit = parseFloat(
                                    modifiedPromo.items
                                        .reduce((acc, item) => {
                                            if (!item.spotItem.isBenefit) {
                                                return acc + item.count;
                                            }
                                            return acc
                                        }, 0)
                                        .toFixed(2)
                                )
                                if (totalCountOfItemsWithoutBenefit % modifiedPromo.promoBuyQty! === 0) {
                                    const benefitItem = modifiedPromo.items.find(basketItem => basketItem.spotItem.isBenefit);
                                    if (benefitItem && modifiedPromo.promoBuyQty && benefitItem.spotItem.id !== newItemsForCurrentPromo[i].spotItem.id) {
                                        const isBenefitItemAlreadyInMyList = modifiedPromo.items.some((item: ItemState) => item.spotItem.id === benefitItem.spotItem.id);
                                        if (isBenefitItemAlreadyInMyList) {
                                            benefitItem.count = totalCountOfItemsWithoutBenefit / modifiedPromo.promoBuyQty!
                                        } else {
                                            promos[modifiedPromoIndex].items = [
                                                ...promos[modifiedPromoIndex].items,
                                                benefitItem
                                            ]
                                        }
                                    }
                                }
                            }

                        }
                    }
                } else {
                    promos = promos.filter((promo: PromosState) => {
                        if (promo.promoId !== selectedSpot!.promoId) {
                            return promo;
                        }
                    })
                }
            } else if (newItemsForCurrentPromo.length) {
                const newPromo: PromosState = {
                    ...promo!,
                    items: newItemsForCurrentPromo
                }
                promos.push(newPromo);
            }
        } else if (newItemsForCurrentPromo.length) {
            const newPromo: PromosState = {
                ...promo!,
                items: newItemsForCurrentPromo
            }
            promos.push(newPromo);
        }
        //check promoSaleType and free items which related to promo 50 and 51
        if (promo?.promoSaleTypeCode === 50 || promo?.promoSaleTypeCode === 51) {
            // find freeItems object for flyer
            // let freeItemsForFlyer: IFreeItemsInPromo[] = localStorage.getItem(`freeItemsForFlyer${flyerBranch?.id}`) ? JSON.parse(localStorage.getItem(`freeItemsForFlyer${flyerBranch?.id}`)!) : [];
            if (freeItemsForFlyer) {
                //find promo which has free item
                const existedPromoInLocalStorage = freeItemsForFlyer.find((promoObj: IFreeItemsInPromo) => promoObj.promoId === promo?.promoId)
                if (existedPromoInLocalStorage) {
                    //checking if promo has freeItems
                    existedPromoInLocalStorage.freeItems = [...newBenefitItemsForCurrentPromo];
                } else {
                    //if promo is NOT existed then put prev state for all promos and add new promo with current free items
                    freeItemsForFlyer = [...freeItemsForFlyer, {
                        promoId: promo?.promoId,
                        freeItems: newBenefitItemsForCurrentPromo
                    }]
                }
            } else {
                //if we don't have in localStorage flyer state for free items
                //then create new one
                freeItemsForFlyer = [{
                    promoId: promo?.promoId,
                    freeItems: newBenefitItemsForCurrentPromo
                }]
            }
        }
        const changesStateForPromos = JSON.stringify(promos);
        const currentStateForPromos = JSON.stringify(myListState.promos);
        if (changesStateForPromos !== currentStateForPromos) {
            dispatch(changeMyListItemsAndBenefitItemsAction({
                promos: promos,
                benefitItems: freeItemsForFlyer
            }));
            dispatch(changeMyListData(true));
        }
    }


    const getTotalItemsCount = (items: ItemState[]): number => {
        return parseFloat(
            items
                .reduce((acc, item) => {
                    return acc + item.count;
                }, 0)
                .toFixed(2)
        )
    }

    const getTotalBenefitItemsCount = (freeQtyItems: IFreeItemDto[]): number => {
        if (promo && promo?.promoSaleTypeCode! === 80) {
            const regularItemsWithoutBenefitItems = items.filter((item: ItemState) => {
                if (!item.spotItem.isBenefit) {
                    return item;
                }
            });
            const totalRegularItemsNumber: number = parseFloat(regularItemsWithoutBenefitItems.reduce((acc, item) => {
                let count = item.count;
                return acc + count;
            }, 0).toFixed(2));
            return Math.floor(totalRegularItemsNumber / (promo?.promoBuyQty ? promo?.promoBuyQty : 0));
        } else {
            if (freeQtyItems.length !== 0) {
                return freeQtyItems.reduce((acc, {itemCount}) => {
                    return acc + itemCount!;
                }, 0)
            } else {
                return 0
            }
        }
    }

    const getTotalItems = (items: ItemState[], promo: IFlyerRuntimePageSpotPromo, freeItems: IFreeItemDto[]): number => {
        const totalItemsNumber: number = parseFloat(items.reduce((acc, item) => {
            let count = item.count;
            if (promo?.promoSellingUnitId && promo?.promoSellingUnitId !== 1 && promo?.promoSellingUnitId !== 8 && promo?.promoSellingUnitId !== 23) {
                count = 1;
            }
            return acc + count;
        }, 0).toFixed(2));
        if (promo?.promoSaleTypeCode! === 50 || promo?.promoSaleTypeCode! === 51) {
            return totalItemsNumber + getTotalBenefitItemsCount(freeItems);
        } else {
            return totalItemsNumber
        }
    };

    const getTotalPrice = (items: ItemState[], promo: IFlyerRuntimePageSpotPromo): number => parseFloat(items.reduce((acc, {
        count,
        spotItem: {regularPrice: price, id: id, isBenefit}
    }) => {
        let itemWhichHasFreeItems = freeQtyItems.find((freeItem: IFreeItemDto) => freeItem.itemID === id);
        if (promo?.promoSellingUnitId && promo?.promoSellingUnitId !== 1 && promo?.promoSellingUnitId !== 8 && promo?.promoSellingUnitId !== 23) {
            return acc + ((price / promo?.promoBuyQty!) * count);
        }
        if ((promo?.promoSaleTypeCode! === 50 || promo?.promoSaleTypeCode! === 51) && itemWhichHasFreeItems) {
            return acc + ((price * count) + (itemWhichHasFreeItems?.itemCount! * price));
        } else if (promo?.promoSaleTypeCode! === 11) {
            return acc + (promo?.promoSalePrice! * count);
        } else {
            if (isBenefit) {
                return acc;
            } else {
                return acc + (price * count);
            }
        }
    }, 0).toFixed(2));

    let counterWidth: string;
    if (isStoreAvailableForFlyer && item.level3CategoryId && !isBenefit && promoItems.length !== 1 && !shelvesScreen.isOpen) {
        if (isTablet) {
            counterWidth = `30%`
        } else {
            counterWidth = `50%`
        }
    } else {
        counterWidth = `100%`
    }

    let salePriceFontSizeFor1item = {
        fontSize: isMobile ? `24px` : `28px`,
        fontWeight: `600`,
        color: `#000000`
    };
    let regPriceFontSizeFor1item = {
        fontSize: isMobile ? `24px` : `28px`,
        fontWeight: `600`,
        color: `#000000`
    };
    let symbolsFontSizeFor1item = {
        fontSize: isMobile ? `14px` : `20px`,
        fontWeight: `600`,
        color: `#000000`
    };
    if (promoItems.length) {
        switch (promoType) {
            case 2:
            case 10:
            case 12:
            case 13:
            case 20:
            case 70:
                salePriceFontSizeFor1item = {
                    fontSize: isMobile ? `24px` : !isExpanded ? `26px` : `32px`,
                    fontWeight: `600`,
                    color: `#000000`
                }
                regPriceFontSizeFor1item = {
                    fontSize: isMobile ? `20px` : !isExpanded ? `22px` : `24px`,
                    fontWeight: `400`,
                    color: `#000000`
                }
                symbolsFontSizeFor1item = {
                    fontSize: isMobile ? `16px` : !isExpanded ? `18px` : `20px`,
                    fontWeight: `400`,
                    color: `#000000`
                };
                break;
            case 62:
            case 63:
                salePriceFontSizeFor1item = {
                    fontSize: isMobile ? `24px` : !isExpanded ? `26px` : `32px`,
                    fontWeight: `600`,
                    color: `#000000`
                }
                regPriceFontSizeFor1item = {
                    fontSize: isMobile ? `24px` : !isExpanded ? `26px` : `32px`,
                    fontWeight: `600`,
                    color: `#000000`
                }
                symbolsFontSizeFor1item = {
                    fontSize: isMobile ? `14px` : !isExpanded ? `16px` : `20px`,
                    fontWeight: `600`,
                    color: `#000000`
                };
                break;
        }
    }

    let heightForItemImage: string = `60%`;
    if (promoItems.length === 2 && !isMobile && isExpanded) {
        heightForItemImage = `75%`
    } else {
        if (isPricelessFlyer) {
            heightForItemImage = `68%`
        }
    }

    let promoCaptionDefault: string[] = promoCaption.split(' / ');

    let allowedProps: any = {"data-item-id": item.id, "data-item-caption": item.displayCaption1};
    let attributesForAddBtnWrap: any = {
        "data-currency-code": settingForPopup?.currencyAbbrv,
    };


    if (promoItems.length !== 1) {
        return (
            <Grid item
                  xs={isTablet ? 4 : isExpanded && promoItems.length !== 2 && !isMobile ? 6 : 6}
                  lg={isTablet ? 4 : isExpanded && promoItems.length !== 2 && !isMobile ? 4 : 6}
                  xl={isTablet ? 4 : isExpanded && promoItems.length !== 2 && !isMobile ? 3 : 6}
            >
                <Box
                    className={classes.itemWrapperNew} sx={{
                    backgroundColor: isBenefit && totalFreeItemsCount !== 0 ? `#D9EAD6` : `#ffffff`,
                    outline: isBenefit && totalFreeItemsCount !== 0 ? `2px solid green` : `none`,
                    height: promoItems.length === 2 && !isMobile && isExpanded ? `500px` : `292px`,
                    margin: `2px`,
                    border: Number(count) > 0 ? `2px solid #38B524` : `2px solid transparent`,
                    position: `relative`
                }}
                    {...allowedProps}
                >
                    {
                        Number(count) > 0 &&
                        <Box className={classes.checkmarkIconBlock} sx={{
                            direction: isRtl ? `rtl` : `ltr`
                        }}>
                            <CheckMarkIcon style={{margin: `10px 8px`}}/>
                            <Typography className={`captionForCheckbox`} fontSize={`14px`} color={`#ffffff`} px={`5px`}
                                        sx={{display: `none`}} dir={isRtl ? `rtl` : `ltr`}>
                                {pickedMultiLangCaption}
                            </Typography>
                        </Box>
                    }

                    <Box className={classes.itemImageWrapper} sx={{
                        height: heightForItemImage,
                        maxHeight: heightForItemImage,
                        minHeight: heightForItemImage,
                        // height: isPricelessFlyer ? (promoItems.length === 2 && !isMobile && isExpanded ? `75%`: `68%`): (promoItems.length === 2 && !isMobile && isExpanded ? `75%`: `60%`),
                        // maxHeight: isPricelessFlyer ? (promoItems.length === 2 && !isMobile && isExpanded ? `75%`: `68%`): (promoItems.length === 2 && !isMobile && isExpanded ? `75%`: `60%`),
                        // minHeight: isPricelessFlyer ? (promoItems.length === 2 && !isMobile && isExpanded ? `75%`: `68%`): (promoItems.length === 2 && !isMobile && isExpanded ? `75%`: `60%`),
                    }}>
                        <ButtonBase
                            onClick={onClick}
                            sx={{
                                width: `100%`,
                                height: `100%`,
                                padding: `5px`,
                                borderRadius: `4px`,
                            }}>
                            {itemImageSrc === "frameScreenshot" ?
                                <canvas ref={canvasRef} style={{
                                    maxWidth: '100%',
                                    maxHeight: '100%'
                                }}></canvas> :
                                <AsyncImage src={image || ""}
                                            setImageExistStatus={setImageExistStatus} isCameraIcon={true}/>
                            }

                        </ButtonBase>
                    </Box>
                    <Box className={classes.itemDetails}>
                        <Box className={classes.itemCaption1} title={promoDisplayCaption}>
                            <Typography fontSize={isMobile ? '16px' : "16px"}>
                                {displayCaption1}
                            </Typography>
                        </Box>
                        <Box className={classes.itemRegPriceWrapper}>
                            <Box className={classes.itemRegPrice}>
                                {
                                    !isPricelessFlyer &&
                                    <>
                                        {
                                            promoType !== 70 &&
                                            <>
                                                <Typography fontSize={isMobile ? '14px' : "12px"}
                                                            textAlign={`start`}>
                                                    {regularPriceCaption} {settingForPopup ? settingForPopup.currencySymbol : " NIS"}
                                                </Typography>
                                                <Typography fontSize={isMobile ? '16px' : "16px"}
                                                            textAlign={`start`}
                                                            sx={{
                                                                textDecoration: promoType === 12 ? `line-through` : `none`,
                                                            }}
                                                >
                                                    {Number(regularPrice).toFixed(2)}
                                                </Typography>
                                            </>
                                        }
                                        {
                                            promoType === 70 &&
                                            <>
                                                <Typography fontSize={isMobile ? '13px' : "12px"}
                                                            textAlign={`start`}>
                                                    {regularPriceCaption} {settingForPopup ? settingForPopup.currencySymbol : " NIS"}
                                                </Typography>
                                                <Typography fontSize={isMobile ? '15px' : isExpanded ? '16px' : "12px"}
                                                            textAlign={`start`}>
                                                    {Number(regularPrice).toFixed(2)}
                                                    {promoQty !== 1 ? ` / ${promoQty} ${promotionSellingUnit?.languageCaption}` : ''}
                                                    {promoQty === 1 ? ` / ${promotionSellingUnit?.languageCaption}` : ''}
                                                </Typography>
                                            </>
                                        }
                                    </>
                                }
                            </Box>
                        </Box>
                        <Box className={classes.itemActions}>
                            <Box className={classes.itemCounter} sx={{
                                display: isVisibleAddBtn ? `flex` : `block`,
                                width: counterWidth,
                                height: promoItems.length === 1 ? `40px` : `28px`,
                            }}>
                                {
                                    isVisibleAddBtn && !isBenefit &&
                                    <Box
                                        className={"add_to_cart"}
                                        sx={{
                                            width: "100%"
                                        }}
                                        {...attributesForAddBtnWrap}
                                    >
                                        <Button className={classes.addItemBtn} onClick={() => {
                                            onClickPlusMinusBtn("increase");
                                        }}>
                                            <Typography>
                                                {addCaption}
                                            </Typography>
                                        </Button>
                                    </Box>
                                }
                                {
                                    !isVisibleAddBtn && !isBenefit &&
                                    <Counter
                                        decrease={() => {
                                            onClickPlusMinusBtn("decrease");
                                        }}
                                        increase={() => {
                                            onClickPlusMinusBtn("increase");
                                        }}
                                        onChangeCountNumber={onChangeCountNumber}
                                        // isHebrewStyle={isHebrewStyle}
                                        count={count}
                                        isBasket={false}
                                        promotionSellingUnit={promotionSellingUnit}
                                        widthPXForBtn={promoItems.length === 1 ? `40px` : `28px`}
                                    />
                                }
                                {
                                    isBenefit &&
                                    <Typography color={`secondary.main`}
                                                className={classes.giftItemWrapper}>
                                        {giftCaption} ({count})
                                    </Typography>
                                }
                            </Box>
                            {
                                isStoreAvailableForFlyer && item.level3CategoryId && !isBenefit && !shelvesScreen.isOpen &&
                                <Box className={`${classes.itemShelfBtn}`}>
                                    <Button onClick={() => {
                                        if (!isMobile) {
                                            if (Boolean(detailsBranch)) {
                                                dispatch(toggleDetailsAction())
                                            }
                                            if (showBasket) {
                                                dispatch(toggleBasket())
                                            }
                                            if (Boolean(addToMyListOneItemData.data)) {
                                                dispatch(setAddToMyListOneItemData(null));
                                            }
                                        }
                                        dispatch(toggleShelvesScreen(item.id));
                                    }}
                                    >
                                        <Typography
                                            color={isLightGuiColor ? "#2A2A2A" : settingForPopup?.primaryColorRgb || "#C32E43"}
                                            sx={{textTransform: 'none'}}
                                            fontSize={`14px`}
                                            fontWeight={900}
                                        >
                                            {showShelfCaption}
                                        </Typography>
                                    </Button>
                                </Box>
                            }

                        </Box>
                    </Box>
                </Box>
            </Grid>
        )
    }
    return (
        <Grid item xs={12} sx={{height: `100%`}}>
            <Box
                className={classes.itemWrapperNew} sx={{
                backgroundColor: isBenefit && totalFreeItemsCount !== 0 ? `#D9EAD6` : `#ffffff`,
                outline: isBenefit && totalFreeItemsCount !== 0 ? `2px solid green` : `none`,
                height: `100%`,
                margin: `0`,
            }}
                {...allowedProps}
            >
                <Grid container height={`inherit`}
                      direction={(isPricelessFlyer || !isExpanded || isMobile) ? `column` : `row`}
                      alignItems={`stretch`} wrap={`nowrap`}>
                    <Grid item xs={isExpanded && !isMobile ? isPricelessFlyer ? 8 : 7 : 12} sx={{
                        height: isExpanded && !isMobile && !isPricelessFlyer ? `100%` : isPricelessFlyer ? `69%` : `57%`,
                        maxHeight: isExpanded && !isMobile && !isPricelessFlyer ? `100%` : isPricelessFlyer ? `69%` : `57%`,
                        minHeight: isExpanded && !isMobile && !isPricelessFlyer ? `100%` : isPricelessFlyer ? `69%` : `57%`,
                    }}>
                        <Box className={classes.itemImageWrapper}>
                            <ButtonBase sx={{
                                width: `100%`,
                                height: `100%`,
                                padding: `5px`,
                                borderRadius: `4px`,
                                border: Number(count) > 0 ? `2px solid #38B524` : `2px solid transparent`
                            }}
                                        disabled={!isImageExist}
                            >
                                {
                                    Number(count) > 0 &&
                                    <Box className={classes.checkmarkIconBlock} sx={{
                                        direction: isRtl ? `rtl` : `ltr`
                                    }}>
                                        <CheckMarkIcon style={{margin: `10px 8px`}}/>
                                        <Typography fontSize={`14px`} color={`#ffffff`} px={`5px`}
                                                    sx={{display: `none`}} dir={isRtl ? `rtl` : `ltr`}>
                                            {pickedMultiLangCaption}
                                        </Typography>
                                    </Box>
                                }
                                {itemImageSrc === "frameScreenshot" ?
                                    <canvas ref={canvasRef} style={{
                                        maxWidth: '100%',
                                        maxHeight: '100%'
                                    }}></canvas> :
                                    <AsyncImage src={image || ""}
                                                setImageExistStatus={setImageExistStatus} isCameraIcon={true}/>
                                }
                            </ButtonBase>
                        </Box>
                    </Grid>
                    <Grid item xs>
                        <Box className={classes.itemDetails}
                             justifyContent={isExpanded && !isMobile ? `center` : `inherit`}
                        >
                            <Box className={classes.promotionDetails}>
                                <Box className={classes.promotionCaption} title={promoDisplayCaption}>
                                    <Typography
                                    >
                                        {promoDisplayCaption}
                                    </Typography>
                                </Box>
                                {
                                    (!isPricelessFlyer || isShowPromoCaption) &&
                                    <Box className={classes.promotionType}>
                                        {
                                            promoCaptionDefault.map((
                                                string: string, index
                                            ) => {
                                                return (
                                                    <Typography
                                                        key={`${index}${string}`}
                                                        sx={{
                                                            fontWeight: index === 0 ? salePriceFontSizeFor1item.fontWeight : symbolsFontSizeFor1item.fontWeight,
                                                            fontSize: index === 0 ? salePriceFontSizeFor1item.fontSize : symbolsFontSizeFor1item.fontSize,
                                                            color: index === 0 ? salePriceFontSizeFor1item.color : symbolsFontSizeFor1item.color
                                                        }}
                                                    >
                                                        {index !== 0 && `/ `} {string} {index === 0 && ` `}
                                                    </Typography>
                                                )
                                            })
                                        }
                                    </Box>
                                }
                            </Box>
                            <Box className={classes.itemRegPriceWrapperForOneItem}>
                                <Box>
                                    {
                                        !isPricelessFlyer &&
                                        <Box
                                            className={classes.itemRegPrice}
                                        >
                                            {
                                                promoType !== 70 && promoType !== 11 && promoType !== 10 && promoType !== 12 &&
                                                <>
                                                    <Typography
                                                        sx={{
                                                            fontWeight: symbolsFontSizeFor1item.fontWeight,
                                                            fontSize: symbolsFontSizeFor1item.fontSize,
                                                            color: symbolsFontSizeFor1item.color
                                                        }}
                                                        textAlign={`start`}>
                                                        {regularPriceCaption} {settingForPopup ? settingForPopup.currencySymbol : " NIS"}
                                                    </Typography>
                                                    <Typography
                                                        sx={{
                                                            fontWeight: regPriceFontSizeFor1item.fontWeight,
                                                            fontSize: regPriceFontSizeFor1item.fontSize,
                                                            color: regPriceFontSizeFor1item.color,
                                                            textDecoration: promoType === 12 || promoType === 13 ? `line-through` : `none`,
                                                        }}
                                                        textAlign={`start`}>
                                                        {Number(regularPrice).toFixed(2)}
                                                    </Typography>
                                                    {
                                                        promoType === 13 &&
                                                        <Typography
                                                            sx={{
                                                                fontWeight: salePriceFontSizeFor1item.fontWeight,
                                                                fontSize: salePriceFontSizeFor1item.fontSize,
                                                                color: salePriceFontSizeFor1item.color,
                                                                margin: `0 5px`
                                                            }}
                                                            textAlign={`start`}>
                                                            {settingForPopup ? settingForPopup.currencySymbol : " NIS"}{Number(regularPrice - promoGetAmountOff).toFixed(2)}
                                                        </Typography>
                                                    }
                                                </>
                                            }

                                            {
                                                promoType === 70 &&
                                                <>
                                                    <Typography
                                                        sx={{
                                                            fontWeight: symbolsFontSizeFor1item.fontWeight,
                                                            fontSize: symbolsFontSizeFor1item.fontSize,
                                                            color: symbolsFontSizeFor1item.color
                                                        }}
                                                        textAlign={`start`}>
                                                        {regularPriceCaption} {settingForPopup ? settingForPopup.currencySymbol : " NIS"}
                                                    </Typography>
                                                    <Typography
                                                        sx={{
                                                            fontWeight: regPriceFontSizeFor1item.fontWeight,
                                                            fontSize: regPriceFontSizeFor1item.fontSize,
                                                            color: regPriceFontSizeFor1item.color
                                                        }}
                                                        textAlign={`start`}>
                                                        {Number(regularPrice).toFixed(2)}
                                                    </Typography>
                                                    {
                                                        promoQty !== 1 &&
                                                        <Typography
                                                            sx={{
                                                                fontWeight: symbolsFontSizeFor1item.fontWeight,
                                                                fontSize: symbolsFontSizeFor1item.fontSize,
                                                                color: symbolsFontSizeFor1item.color
                                                            }}
                                                        >
                                                            {` / ${promoQty} ${promotionSellingUnit?.languageCaption}`}
                                                        </Typography>
                                                    }
                                                    {
                                                        promoQty === 1 &&
                                                        <Typography
                                                            sx={{
                                                                fontWeight: symbolsFontSizeFor1item.fontWeight,
                                                                fontSize: symbolsFontSizeFor1item.fontSize,
                                                                color: symbolsFontSizeFor1item.color
                                                            }}
                                                        >
                                                            {` / ${promotionSellingUnit?.languageCaption}`}
                                                        </Typography>
                                                    }
                                                </>
                                            }
                                        </Box>
                                    }
                                </Box>
                                <Box>
                                    {
                                        isStoreAvailableForFlyer && item.level3CategoryId && !isBenefit && !shelvesScreen.isOpen &&
                                        <Box className={`${classes.itemShelfBtn}`}>
                                            <Button onClick={() => {
                                                if (!isMobile) {
                                                    if (Boolean(detailsBranch)) {
                                                        dispatch(toggleDetailsAction())
                                                    }
                                                    if (Boolean(addToMyListOneItemData.data)) {
                                                        dispatch(setAddToMyListOneItemData(null));
                                                    }
                                                    if (showBasket) {
                                                        dispatch(toggleBasket())
                                                    }
                                                }
                                                dispatch(toggleShelvesScreen(item.id));
                                            }}
                                            >
                                                <Typography
                                                    color={isLightGuiColor ? "#2A2A2A" : settingForPopup?.primaryColorRgb || "#C32E43"}
                                                    sx={{textTransform: 'none', fontWeight: `900`}}
                                                    fontSize={`14px`}
                                                >
                                                    {showShelfCaption}
                                                </Typography>
                                            </Button>
                                        </Box>
                                    }
                                </Box>
                            </Box>
                            <Box className={classes.promotionDate}>
                                <Typography
                                >
                                    {validToCaption} {toDate}
                                </Typography>
                            </Box>
                            {
                                !isPricelessFlyer &&
                                <Box className={classes.promotionPricesSection} sx={{
                                    flex: isExpanded && !isMobile ? `none` : `1 1 auto`,
                                }}
                                >
                                    {
                                        promoType === 11 &&
                                        <Grid container
                                              className={`${classes.promotionTotalPrice} ${classes.orderCostInfoRowNew}`}>
                                            {
                                                totalItemsCount !== 0 &&
                                                <>
                                                    <Grid item xs={8}>
                                                        <Typography>{salePriceCaption} ({totalItemsCount} {itemsCaption})</Typography>
                                                    </Grid>
                                                    <Grid item xs>
                                                        <Typography
                                                            className={`textAlignEnd`}>{settingForPopup ? settingForPopup.currencySymbol : "NIS"}{Number(totalSalePrice).toFixed(2)}</Typography>
                                                    </Grid>
                                                </>
                                            }
                                        </Grid>
                                    }
                                    {
                                        promoType !== 11 &&
                                        <>
                                            <Grid container
                                                  className={`${classes.promotionRegPrice} ${classes.orderCostInfoRowNew}`}>
                                                <Grid item xs={8}>
                                                    <Typography>{totalCaption} ({totalItemsCount} {itemsCaption})</Typography>
                                                </Grid>
                                                <Grid item xs>
                                                    <Typography
                                                        className={`textAlignEnd`}>{settingForPopup ? settingForPopup.currencySymbol : "NIS"}{Number(totalRegularPrice).toFixed(2)}</Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container
                                                  className={`${classes.promotionSaving} ${classes.orderCostInfoRowNew}`}>
                                                {
                                                    discount !== 0 &&
                                                    <>
                                                        <Grid item xs={8}>
                                                            <Typography>{totalFreeItemsCount !== 0 ? `${discountCaption} (${totalFreeItemsCount} ${freeItemsCaption})` : discountCaption}</Typography>
                                                        </Grid>
                                                        <Grid item xs>
                                                            <Typography
                                                                className={`textAlignEnd`}>{settingForPopup ? settingForPopup.currencySymbol : "NIS"}{discount.toFixed(2)}</Typography>
                                                        </Grid>
                                                    </>
                                                }
                                            </Grid>

                                            <Grid container
                                                  className={`${classes.promotionTotalPrice} ${classes.orderCostInfoRowNew}`}>
                                                <Grid item xs={8}>
                                                    <Typography>{salePriceCaption}</Typography>
                                                </Grid>
                                                <Grid item xs>
                                                    <Typography
                                                        className={`textAlignEnd`}>{settingForPopup ? settingForPopup.currencySymbol : "NIS"}{Number(totalSalePrice).toFixed(2)}</Typography>
                                                </Grid>
                                            </Grid>
                                        </>
                                    }
                                </Box>
                            }
                            <Box
                                className={`${classes.itemActions} ${isPricelessFlyer && classes.pricelessDesignActions}`}>
                                <Box className={classes.itemCounter} sx={{
                                    display: isVisibleAddBtn ? `flex` : `block`,
                                    width: counterWidth,
                                    height: promoItems.length === 1 ? `40px` : `28px`,
                                }}>
                                    {
                                        isVisibleAddBtn && !isBenefit &&
                                        <Box
                                            className={"add_to_cart"}
                                            sx={{
                                                width: "100%"
                                            }}
                                            {...attributesForAddBtnWrap}
                                        >
                                            <Button className={classes.addItemBtn} onClick={() => {
                                                onClickPlusMinusBtn("increase");
                                            }}>
                                                <Typography>
                                                    {addCaption}
                                                </Typography>
                                            </Button>
                                        </Box>
                                    }
                                    {
                                        !isVisibleAddBtn && !isBenefit &&
                                        <Counter
                                            decrease={() => {
                                                onClickPlusMinusBtn("decrease")
                                            }}
                                            increase={() => {
                                                onClickPlusMinusBtn("increase")
                                            }}
                                            // isHebrewStyle={isHebrewStyle}
                                            onChangeCountNumber={onChangeCountNumber}
                                            count={count}
                                            isBasket={false}
                                            promotionSellingUnit={promotionSellingUnit}
                                            widthPXForBtn={promoItems.length === 1 ? `40px` : `28px`}
                                        />
                                    }
                                    {
                                        isBenefit &&
                                        <Typography color={`secondary.main`}
                                                    className={classes.giftItemWrapper}>
                                            {giftCaption} ({count})
                                        </Typography>
                                    }
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Grid>
    );
};
